import React from "react";
import SectionTitle from "../../components/SectionTitle";
import SingleService from "../../components/Service/SingleService";
import serviceImg1 from "../../assets/images/about/who-1.png";
import serviceImg2 from "../../assets/images/about/who-2.png";
import serviceImg3 from "../../assets/images/about/who-3.png";
import serviceImg4 from "../../assets/images/about/who-4.png";
import Slider from "react-slick";

const Service = () => {
  const serviceSettings = {
    dots: false,
    arrows: false,
    infinite: true,
    centerMode: false,
    autoplay:true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          arrows: false,
        },
      },
    ],
  };

  // const data = [
  //   {
  //     img: serviceImg1,
  //     title: "End poverty by uplifting and valuing our skilled labour force",
  //   },
  //   { img: serviceImg2, 
  //     title: "Empower women to empower society" },
  //   {
  //     img: serviceImg3,
  //     title: "Build a better future for women—build a better future for all",
  //   },
  //   {
  //     img: serviceImg4,
  //     title: "Ensure financial stability for every household",
  //   },
  //   {
  //     img: serviceImg1,
  //     title: "Create a disease-free, poverty-free, and joyful India",
  //   },
  // ];

    const data = [
    {
      img: "/img/goals/uplifting.png",
      title: "End poverty by uplifting and valuing skilled labour",
    },
    { img: "/img/goals/women.jpg", 
      title: "Empower women to build a stronger, inclusive society" },
    {
      img: "/img/goals/secure.jpg",
      title: "Create opportunities to secure women’s future",
    },
    {
      img: "/img/goals/financial.jpg",
      title: "Ensure financial stability for every Indian household",
    },
    {
      img: "/img/goals/joyful.jpg",
      title: "Build a joyful, disease-free, and poverty-free nation",
    },
  ];

  return (
    <div className="react_popular_topics  pb---70">
      <div className="container">
        <SectionTitle Title="Ocfit " subtitle="Goals" />
        <h4 className="font-bold text-center">
          OCFIT GOALS for a Stronger India
        </h4>
        <div className="event-slider owl-carousel wow animate__fadeInUp" data-wow-duration="0.3s">
        <Slider {...serviceSettings}>
          {data?.map((item, idx) => (
            <div
              className=" wow animate__fadeInUp px-2"
              data-wow-duration="0.3s"
              key={idx}
            >
              <SingleService
                itemImg={item.img}
                title={item.title}
              />
            </div>
          ))}
        </Slider>
        </div>

        {/* <div className="row">
                    <div className="col-lg-3 wow animate__fadeInUp" data-wow-duration="0.3s">
                        <SingleService
                            itemImg={serviceImg2}
                            title="End poverty by uplifting and valuing our skilled labour force"
                        />
                    </div>
                    <div className="col-lg-3 wow animate__fadeInUp" data-wow-duration="0.5s">
                        <SingleService
                            itemImg={serviceImg1}
                            title="Empower women to empower society"
                        />
                    </div>
                    <div className="col-lg-3 wow animate__fadeInUp" data-wow-duration="0.7s">
                        <SingleService
                            itemImg={serviceImg3}
                            title="Build a better future for women—build a better future for all"
                        />
                    </div>
                    <div className="col-lg-3 wow animate__fadeInUp" data-wow-duration="0.9s">
                        <SingleService
                            itemImg={serviceImg4}
                            title="Ensure financial stability for every household"
                        />
                    </div>
                </div> */}
      </div>
    </div>
  );
};

export default Service;
